import type { TestingSchedule } from '../schemas/testingSchedules'
import { TESTING_AMOUNTS, scheduleTestingAmount } from './continuousTestingSetup'

// Schedules use quarter-hour boundaries. Search those real instants so DST
// gaps and repeated hours follow the scheduler's local occurrence keys.
export function nextTestingTime(schedule: TestingSchedule, now = new Date()): Date | null {
  const { config, last_occurrence } = schedule
  if (!config.enabled) return null
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: config.timezone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23',
  })
  const start = Math.ceil(now.getTime() / 60000) * 60000
  for (let time = start; time < start + 32 * 86400000; time = (Math.floor(time / 900000) + 1) * 900000) {
    const parts = formatter.formatToParts(time)
    const part = (name: Intl.DateTimeFormatPartTypes) => parts.find(p => p.type === name)!.value
    const key = `${part('year')}-${part('month')}-${part('day')}${config.cadence === 'hourly' ? `T${part('hour')}` : ''}`
    if (key === last_occurrence) continue
    if (config.cadence === 'weekly' && ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(part('weekday')) !== config.weekday) continue
    if (config.cadence === 'monthly' && Number(part('day')) !== config.month_day) continue
    const minute = Number(part('minute'))
    if (config.cadence === 'hourly' ? minute < config.minute : Number(part('hour')) * 60 + minute < config.hour * 60 + config.minute) continue
    return new Date(time)
  }
  return null
}

export function testingScheduleSummary(schedules: TestingSchedule[], now = new Date()): string {
  return schedules.filter(schedule => schedule.config.enabled).map(schedule => {
    const amount = TESTING_AMOUNTS.find(amount => amount.journeys === scheduleTestingAmount(schedule))!
    const next = nextTestingTime(schedule, now)
    const time = next && new Intl.DateTimeFormat(undefined, {
      timeZone: schedule.config.timezone, month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
    }).format(next)
    return `${amount.name} test ${schedule.config.cadence}.${time ? ` Next test at ${time}.` : ''}`
  }).join(' ')
}
